import css from '@emotion/css';

// https://coolors.co/palette/264653-2a9d8f-e9c46a-f4a261-e76f51

export default css `
    html, body, * {
        font-family: 'Lato', sans-serif;
        font-weight: 300;

        b, strong {
            font-weight: 700;
        }
    }

    html {
        scroll-behavior: smooth;
    }

    html, body {
        font-size: 16px;
    }

    h1, h2, h3, h4, h5, h6 {
        font-size: 100%;
    }

    p, span {
        line-height: 120%;
    }
`;
